import React, { useEffect, useRef, useState } from 'react';
import ScreenOrientation from 'enum/ScreenOrientation';
import classNames from 'classnames';
import { QRCodeSVG } from 'qrcode.react';
import bgTemplate1Titulo from '../../assets/images/bg_template_1_titulo.png';
import bgTemplate1Descricao from '../../assets/images/bg_template_1_descricao.png';

type InternalsNewsTemplatesProps = {
  title: string;
  description: string;
  photoCredit?: string;
  bgImage?: string;
  logo?: string;
  qrCode?: string;
  color?: string;
  className?: string;
  screenOrientation?: ScreenOrientation;
};

const Template1 = ({
  title,
  description,
  logo,
  photoCredit,
  bgImage,
  qrCode,
  color,
  className,
  screenOrientation
}: InternalsNewsTemplatesProps) => {
  const aspectRatioClass =
    screenOrientation === ScreenOrientation.PORTRAIT
      ? 'aspect-ratio-box-9-16-news'
      : 'aspect-ratio-box-16-9-news';

  const logoContainerRef = useRef<HTMLDivElement | null>(null);

  const hexToRgb = (hex: string) => {
    let r = 0,
      g = 0,
      b = 0;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }
    return `${r}, ${g}, ${b}`;
  };

  const [isLoaded, setIsLoaded] = useState(false);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  useEffect(() => {
    if (logoContainerRef.current) {
      const rgbColor = color ? hexToRgb(color) : 'transparent';
      logoContainerRef.current.style.setProperty('--logo-bg-color', rgbColor);
    }
  }, [color]);

  return (
    <div className={classNames(aspectRatioClass, className)}>
      <div className="bg-image">
        <img
          className={classNames({ loaded: isLoaded })}
          src={bgImage}
          alt="Imagem de fundo"
          onLoad={handleLoad}
        />
      </div>
      <div
        ref={logoContainerRef}
        className={classNames('container-logo-title-description')}
      >
        {logo && (
          <div className={classNames('logo')}>
            <img src={logo} alt="Logo" />
          </div>
        )}
        <div className={classNames('title-description')}>
          <div
            className={classNames('title-container')}
            style={{
              backgroundImage: `url(${bgTemplate1Titulo})`
            }}
          >
            <h1 className={classNames('title')}>{title}</h1>
          </div>
          <div
            className={classNames('description-container')}
            style={{
              backgroundImage: `url(${bgTemplate1Descricao})`
            }}
          >
            <p className={classNames('description')}>{description}</p>
          </div>
        </div>
      </div>
      <div className={classNames('photo-credit')}>
        <p>Foto: {photoCredit}</p>
      </div>
      {qrCode && (
        <div className={classNames('qrCode')}>
          <QRCodeSVG value={qrCode} />
        </div>
      )}
    </div>
  );
};

export { Template1 };
